var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0625 0.5625H17.9375V1.9375H0.0625V0.5625ZM0.0625 3.3125H12.4375V4.6875H0.0625V3.3125ZM0.0625 6.0625H17.9375V7.4375H0.0625V6.0625ZM0.0625 8.8125H12.4375V10.1875H0.0625V8.8125ZM0.0625 11.5625H17.9375V12.9375H0.0625V11.5625Z",
    fill: "#778CA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescIcon);
export default __webpack_public_path__ + "static/media/descIcon.f85955b44c5cdff59a601dcb94ca42cf.svg";
export { ForwardRef as ReactComponent };